















import { defineComponent, PropType, toRef } from 'vue';
import { useChildFilter } from '../../composables/documents/useChildFilter';
import { iconClassEnum } from '../../../shared/enums/iconClassEnum';
import AulaMultiselect from '../../../shared/components/select/AulaMultiselect.vue';
import { RegardingInstitutionProfile } from '../../../shared/types';

export default defineComponent({
  name: 'DocumentChildFilter',
  components: { AulaMultiselect },
  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    value: { type: Array as PropType<number[] | string[]>, default: () => [] },
    children: { type: Array as PropType<RegardingInstitutionProfile[]>, required: true },
  },
  emits: ['change'],
  setup(props, { emit }) {
    const children = toRef(props, 'children');
    const { options } = useChildFilter(children);

    const emitChange = childId => {
      emit('change', childId);
    };

    return {
      options,
      emitChange,
      iconClassEnum,
    };
  },
});
